import React from "react";
import s from "./style.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import { wordwrap } from "d3-jetpack";

const margin = {
  top: 60,
  right: 50,
  bottom: 50,
  left: 50,
};

const Pathways = ({ data, title, note, source, pathway, pathways, topBox }) => {
  const { ref, width } = useVizualisation();

  const height = 350;

  const rectWidth = 200;
  const rectHeight = 100;
  const rectMargin = 20;

  const w = 650 - margin.left - margin.right;
  const h = height - margin.top - margin.bottom;

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg viewBox="0 0 650 350">
        <defs>
          <marker
            id="arrowhead"
            markerWidth="3"
            markerHeight="3"
            refX="0"
            refY="1.5"
            orient="auto"
            fill="#000"
          >
            <polygon points="0 0, 3 1.5, 0 3" />
          </marker>
          <filter id="dropshadow" height="130%">
            <feDropShadow
              dx="6"
              dy="6"
              stdDeviation="5"
              floodColor="#0C5860"
              floodOpacity="0.2"
            />
          </filter>
        </defs>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          {pathways.map((d, i) => (
            <g
              key={`pathway-${i}`}
              className={s.pathway}
              transform={`translate(${
                w / 2 -
                rectWidth / 2 -
                (pathways.length / 2) * (rectWidth + rectMargin / 2) +
                i * (rectWidth + rectMargin / 2) +
                rectWidth / 2
              }, ${150})`}
              opacity={i === +pathway ? 1 : i <= +pathway ? 0.5 : 0}
            >
              <path
                d={`M ${
                  rectWidth / 2 +
                  (i === 0
                    ? rectWidth + rectMargin / 2
                    : i === 2
                    ? -rectWidth - rectMargin / 2
                    : 0)
                } ${-150 + rectHeight / 2} Q ${rectWidth / 2} ${
                  -150 + rectHeight / 2
                } ${rectWidth / 2} ${-10}`}
                stroke="#000"
                fill="none"
                style={{
                  strokeWidth: 3,
                  markerEnd: "url(#arrowhead)",
                }}
              />
              <rect
                width={rectWidth}
                height={rectHeight}
                rx={15}
                ry={15}
                style={{ filter: "url(#dropshadow)" }}
              />
              <text className={s.boxLabel} x={rectWidth / 2} y={rectHeight / 2}>
                {wordwrap(d.text, 18).map((t, j) => (
                  <tspan
                    key={`token=${j}`}
                    x={rectWidth / 2}
                    y={
                      rectHeight / 2 +
                      j * 16 -
                      ((wordwrap(d.text, 18).length - 1) * 16) / 2
                    }
                  >
                    {t}
                  </tspan>
                ))}
              </text>
            </g>
          ))}
          <g
            className={s.pid}
            transform={`translate(${w / 2 - rectWidth / 2}, 0)`}
          >
            <rect
              y={rectHeight / 4}
              width={rectWidth}
              height={rectHeight / 2}
              rx={15}
              ry={15}
            />
            <text className={s.boxLabel} x={rectWidth / 2} y={rectHeight / 2}>
              {wordwrap(topBox, 16).map((t, j) => (
                <tspan
                  key={`token=${j}`}
                  x={rectWidth / 2}
                  y={
                    rectHeight / 2 +
                    j * 16 -
                    ((wordwrap(topBox, 16).length - 1) * 16) / 2
                  }
                >
                  {t}
                </tspan>
              ))}
            </text>
          </g>
        </g>
      </svg>
    </Vizualisation>
  );
};

export default Pathways;
